import { render, staticRenderFns } from "./club-points-history-table.vue?vue&type=template&id=9569382a&"
import script from "./club-points-history-table.vue?vue&type=script&lang=js&"
export * from "./club-points-history-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9569382a')) {
      api.createRecord('9569382a', component.options)
    } else {
      api.reload('9569382a', component.options)
    }
    module.hot.accept("./club-points-history-table.vue?vue&type=template&id=9569382a&", function () {
      api.rerender('9569382a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-table/club-points-history-table.vue"
export default component.exports